var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36176 0H16.6415C16.6531 0.00380745 16.6646 0.00819044 16.6761 0.0125643C16.7007 0.0219689 16.7253 0.0313315 16.7506 0.03484C18.291 0.247307 19.5201 1.35248 19.8959 2.86602C19.923 2.97488 19.9451 3.08503 19.9671 3.19525C19.978 3.24983 19.9889 3.30444 20.0004 3.35892V16.6387C19.9967 16.65 19.9925 16.6613 19.9882 16.6726C19.9787 16.6977 19.9692 16.7229 19.9656 16.7489C19.6915 18.6434 18.1602 19.9913 16.2389 19.9953C13.1805 20.0016 10.1225 20.0002 7.06428 19.9988C5.96302 19.9983 4.86174 19.9978 3.76042 19.9976C3.22697 19.9976 2.70437 19.9165 2.22632 19.6772C0.797876 18.9627 0.0125474 17.8193 0.00569364 16.2C-0.00192565 14.4544 -0.000253413 12.7085 0.00141891 10.9625C0.0021284 10.2218 0.0028379 9.48104 0.0028379 8.74028C0.0028379 8.2315 0.00240529 7.72272 0.00197269 7.21396C0.000999383 6.0693 2.61515e-05 4.92473 0.0039802 3.78043C0.0102628 2.10811 1.01834 0.705368 2.58843 0.182767C2.75903 0.126288 2.93654 0.0897323 3.11408 0.0531715C3.19687 0.0361222 3.27966 0.019072 3.36176 0ZM8.55078 10.6187L3.53163 4H7.4L10.6905 8.33909L14.7628 4H15.8996L11.1983 9.00909L16.5 16H12.6316L9.05887 11.2885L4.63682 16H3.5L8.55078 10.6187ZM6.98048 4.82578H5.20337L13.0509 15.1742H14.828L6.98048 4.82578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.48d41201b384148f017f6103b22dd1e5.svg";
export { ForwardRef as ReactComponent };